export enum DetailsFields {
    status = "Status",
    "sequenceNumber" = "SequenceNumber",
    "unitNumber" = "UnitNumber",
    "modelNumber" = "ModelNumber",
    "modelFull" = "ModelDescription",
    "inspectionTask" = "InspectionTask",
}
export enum DetailsFieldsDD {
    statusId = "Status",
    "dd01" = "SequenceNumber",
    "dd02" = "UnitNumber",
    "modelNumber" = "ModelNumber",
    "modelDescription" = "ModelDescription",
    "taskDescription" = "InspectionTask",
}
export enum MoreDetailsFields {
    "projectNumber" = "Project",
    "disciplineId" = "Discipline",
    "assignedOn" = "AssignedTo",
}
export enum MoreDetailsFieldsDD {
    "projectNumber" = "Project",
    "disciplineId" = "Discipline",
    "assignedOn" = "AssignedTo", // ??
}

export enum SapVersion {
    R3 = 1,
    S4HANA = 2,
}

